exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 600px), print {\n  .republishPanel-3UFTR {\n    display: none;\n  }\n}", ""]);

// Exports
exports.locals = {
	"republishPanel": "republishPanel-3UFTR"
};